export default __webpack_public_path__ + "static/media/MW.33e950c6.svg";